// Story 6.9 (ADO-1163, AC3) — Toggle / switch. Figma Filters Switch 615:15.
//
// a11y (NFR24–26): a native <button role="switch"> with aria-checked, keyboard
// operable (Space/Enter) for free, visible focus ring. The optional visible
// label is a native <label htmlFor> — <button> is a labelable element, so
// clicking the label toggles the switch natively (click-through parity with
// Checkbox) with no extra handler. When there is no visible label, pass
// `aria-label`.

import { useId } from 'react';
import styles from './Toggle.module.css';

export interface ToggleProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  /** Optional visible label rendered before the switch. */
  label?: string;
  /** Accessible name when there is no visible `label`. */
  'aria-label'?: string;
  disabled?: boolean;
  id?: string;
  /**
   * Story 8.13 (ADO-2022): below desktop the row fills its container with the switch at the far
   * right; on desktop it keeps the inline label-then-switch layout.
   */
  spreadBelowDesktop?: boolean;
}

export function Toggle({
  checked,
  onChange,
  label,
  disabled,
  id,
  'aria-label': ariaLabel,
  spreadBelowDesktop,
}: ToggleProps) {
  const reactId = useId();
  const buttonId = id ?? reactId;

  return (
    <span className={styles.root} data-spread={spreadBelowDesktop ? 'below-desktop' : undefined}>
      {label ? (
        <label className={styles.label} htmlFor={buttonId}>
          {label}
        </label>
      ) : null}
      <button
        type="button"
        id={buttonId}
        role="switch"
        aria-checked={checked}
        aria-label={label ? undefined : ariaLabel}
        disabled={disabled}
        className={styles.switch}
        onClick={() => onChange(!checked)}
      >
        <span className={styles.knob} />
      </button>
    </span>
  );
}
